
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-register");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/register/index.js
// module id = C77t
// module chunks = 11